// Shared labels and formatting for the sales inbox.

export const KIND_OPTIONS = [
  ['dealership', 'Dealership'],
  ['body_shop', 'Body shop'],
  ['manufacturer', 'Manufacturer / parts'],
  ['insurance', 'Insurance adjuster'],
  ['other', 'Other'],
];

export const STATUS_OPTIONS = [
  ['new', 'New'],
  ['contacted', 'Contacted'],
  ['qualified', 'Qualified'],
  ['quoted', 'Quoted'],
  ['won', 'Won'],
  ['lost', 'Lost'],
  ['spam', 'Spam'],
];

export const statusClass = (status) => `inbox-status-${status}`;

// Date-only values ("2026-10-20") are calendar days: parse them as local dates so
// they don't shift a day west of UTC.
const toDate = (value) => {
  if (!value) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split('-').map(Number);
    return new Date(y, m - 1, d);
  }
  return new Date(value);
};

export const formatShortDate = (value) => {
  const date = toDate(value);
  if (!date) return '';
  const sameYear = date.getFullYear() === new Date().getFullYear();
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', ...(sameYear ? {} : { year: 'numeric' }) });
};

export const formatDateTime = (value) => {
  const date = toDate(value);
  if (!date) return '';
  return date.toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
};

export const localDateInput = (date = new Date()) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

// The work order form wants exactly 10 digits.
export const tenDigitPhone = (phone) => {
  let digits = (phone || '').replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
  return digits.length === 10 ? digits : '';
};

export const errorMessage = (err, fallback) => {
  const data = err && err.response && err.response.data;
  if (!data) return fallback;
  if (typeof data === 'string') return fallback;
  if (data.error) return data.error;
  if (data.detail) return data.detail;
  const first = Object.entries(data)[0];
  if (first) return `${first[0]}: ${[].concat(first[1]).join(' ')}`;
  return fallback;
};
